import React, { useState, useEffect } from "react";
import { FaGlobe, FaMicrochip, FaShieldAlt, FaHandPointUp, FaFileAlt, FaBolt, FaChartLine, FaStar } from "react-icons/fa";

import { About } from "./about";
import { Services } from "./services";
import { Features } from "./features";
import { Team } from "./Team";
import { Gallery } from "./gallery";
import { WhyChooseUs} from "./WhyChooseUs";

import JsonData from "../data/data.json";
import { useLocation } from "react-router-dom";
import "../App.css";
import { Slidershow } from "./slidershow";
import { LdServices } from "./ldserv";
import { scrollToSectionId } from "../utils/scrollToSection";

const Landing = () => {
  const location = useLocation();
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  /* Scroll quando a URL traz hash (entrada direta, F5 ou vindo de outra rota) */
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace(/^#/, "");
    if (!id) return;
    const t = window.setTimeout(() => scrollToSectionId(id), 120);
    return () => clearTimeout(t);
  }, [location.pathname, location.hash]);

   const items = [
    { icon: <FaGlobe />, label: "100% Digital" },
    { icon: <FaMicrochip />, label: "Tecnológico" },
    { icon: <FaShieldAlt />, label: "Seguro" },
    { icon: <FaHandPointUp />, label: "Sem burocracia" },
    { icon: <FaFileAlt />, label: "Acessível" },
    { icon: <FaBolt />, label: "Inovador" },
    { icon: <FaChartLine />, label: "Transparente" },
    { icon: <FaStar />, label: "Humano" },
  ];

  return (
    <div>
      <Slidershow />
      <About data={landingPageData.About} />
      <WhyChooseUs
        title="Tudo que um banco digital precisa ser"
        items={items}
      />
      <LdServices data={landingPageData.Services} />
      <Services data={landingPageData.Services2} />
      <Features data={landingPageData.Features} />
      <Team data={landingPageData.Team} />
      <Gallery data={landingPageData.Gallery} />
    </div>
  );
};

export default Landing;
